"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var useEditableClassName_1 = require("./useEditableClassName");
var useMarginAndPaddingStyle_1 = require("./useMarginAndPaddingStyle");
var useColorStyle_1 = require("./useColorStyle");
exports.useConfigurableStyle = function (_a) {
    var defaultClassName = _a.defaultClassName, additionalClassName = _a.additionalClassName, overrideDefaultClassName = _a.overrideDefaultClassName, marginType = _a.marginType, paddingType = _a.paddingType, backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, borderColor = _a.borderColor, styleProp = _a.styleProp;
    var _style = (styleProp && typeof styleProp === "object") ? styleProp : {};
    var _b = useMarginAndPaddingStyle_1.useMarginAndPaddingStyle({ margin: marginType, padding: paddingType }), marginPaddingClassNames = _b[0], marginPaddingStyle = _b[1];
    var _c = useColorStyle_1.useColorStyle({ backgroundColor: backgroundColor, fontColor: fontColor, borderColor: borderColor }), colorClassNames = _c[0], colorStyle = _c[1];
    var editedClassName = useEditableClassName_1.useEditableClassName(defaultClassName, additionalClassName, overrideDefaultClassName);
    var mergedClassName = classnames_1.default(editedClassName, marginPaddingClassNames, colorClassNames);
    var style = __assign(__assign(__assign({}, marginPaddingStyle), colorStyle), _style);
    return [mergedClassName, style];
};
